import { render, staticRenderFns } from "./AuditImgDialog.vue?vue&type=template&id=16f8c406&scoped=true"
import script from "./AuditImgDialog.vue?vue&type=script&lang=js"
export * from "./AuditImgDialog.vue?vue&type=script&lang=js"
import style0 from "./AuditImgDialog.vue?vue&type=style&index=0&id=16f8c406&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f8c406",
  null
  
)

export default component.exports